// extracted by mini-css-extract-plugin
export default {"screenXsMax":"(max-width: 768px)","header":"styles_header__vD5uI","group":"styles_group__aMMdY","materialListing":"styles_materialListing__fs-Hj"};